import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';



import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;


@Injectable()
export class CancelParticipationService {

  constructor(private http: HttpClient,
    private httpClientService: HttpClientService,
    private utilityService: UtilityService,
    private adobeAnalyticsService: AdobeAnalyticsService) {

    }

 fetchJSON(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers())
    .pipe(
       map((test: HttpResponse<any>) => {
      if (sessionStorage.getItem('sapmp_jwtToken') != null) {
        // refreshes token for logged in scenario upon page load
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
      }
     return test.body })
      ,catchError( this.handleError ));

  }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }
  getFanStatusSummary(companyId) {
    // will be calling actual api with company id;
    let apiUrl;
      apiUrl = this.utilityService.getEnvConfig().dashboardSummary;
      //apiUrl = "assets/mock/dashboard/getFANListMock6.json";
    
    return this.httpClientService.get(apiUrl, this.get_headers())
    .pipe(
       map((res: HttpResponse<any>) => {
      // if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      //   // refreshes token for logged in scenario upon page load
      //   this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
      // }
      return res.body;
    })
      ,catchError( this.handleError ));
  }

  getFANList(companyid) {
    // here we concat companyid with /device/deployement/fan/{companyid}
    let fanUrl;
    if (this.utilityService.getEnvConfig().useMock) {
      
      fanUrl = "assets/mock/dashboard/getFANListMock3.json";
      
    } else {
      fanUrl = this.utilityService.getEnvConfig().getFANList;
    }
    return this.fetchJSON(fanUrl);
  }

  // From Select Fan Tab
  saveCancelledFAN(allFanList, cancelledFanList, selectedColumn) {
    // console.log(allFanList, cancelledFanList, selectedColumn);
    sessionStorage.setItem('CancelParticipationData', JSON.stringify({ allFanList, cancelledFanList, selectedColumn }));
  }

  saveReviewedFan(reviewedData) {
    const cancelData = {
      fanList: reviewedData.map(item => item.fanId)
    };
    //sessionStorage.setItem('ReviewedData', JSON.stringify({ reviewedData }));
    if (this.utilityService.getEnvConfig().useMock) {
       sessionStorage.setItem('ReviewedData', JSON.stringify({ reviewedData }));
    } else {
      sessionStorage.setItem('ReviewedData', JSON.stringify({ reviewedData }));
      return this.httpClientService.post(this.utilityService.getEnvConfig().submitCancelParticipation, cancelData, this.get_headers())
        .pipe(
       map((test: HttpResponse<any>) => test)
        ,catchError( this.handleError ));
    }
  }

  saveUnclaimDevicesFan(allFanList, cancelledFanList, selectedColumn) {
    sessionStorage.setItem('UnclaimDevicesData', JSON.stringify({ allFanList, cancelledFanList, selectedColumn }));
  }

  saveRemoveDevices(removedData) {
    if (this.utilityService.getEnvConfig().useMock) {
       sessionStorage.setItem('RemovedData', JSON.stringify({ removedData }));
       //local backend call
      //  return this.httpClientService.post(this.utilityService.getEnvConfig().cancelOEMUrl, removedData, this.get_headers())
      //   .pipe(
      //  map((test: HttpResponse<any>) => test)
      //   ,catchError( this.handleError ));

    } else {
      sessionStorage.setItem('RemovedData', JSON.stringify({ removedData }));
      return this.httpClientService.post(this.utilityService.getEnvConfig().cancelOEMUrl, removedData, this.get_headers())
        .pipe(
       map((test: HttpResponse<any>) => test)
        ,catchError( this.handleError ));
    }
  }


  createPageLoadProperties(url, section2) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS['FRIENDLY_NAME_CANCELPARTICIPATION_' + url];
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_CANCELPARTICIPATION;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_REPRESENTATIVE_IPADDR] = ANALYTICS_CONSTANTS.GLOBAL_USER_REPRESENTATIVE_IPADDR;

    // dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION] = 'Cancel Participation';
     dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION1] = section2;
    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  getRemovedFanData() {
    return sessionStorage.getItem('RemovedData') ? JSON.parse(sessionStorage.getItem('RemovedData')) : false;
  }

  getReviewedFanData() {
    return sessionStorage.getItem('ReviewedData') ? JSON.parse(sessionStorage.getItem('ReviewedData')) : false;
  }

  getCancelledFanData() {
    return sessionStorage.getItem('CancelParticipationData') ? JSON.parse(sessionStorage.getItem('CancelParticipationData')) : false;
  }

  removeCancelledFanData() {
    sessionStorage.removeItem('CancelParticipationData');
  }

  getUnclaimDevicesData() {
    return sessionStorage.getItem('UnclaimDevicesData') ? JSON.parse(sessionStorage.getItem('UnclaimDevicesData')) : false;
  }


  indexOfObjectbyValue(data, field, search) {
    let i = 0;
    let ind = -1;
    for (let cols of data) {
      if (cols[field] === search) {
        ind = i;
      }
      i++;
    }
    return ind;
  }

  handleError = (error) => {
    return throwError(error);
  }

  pageContent(dataurl) {
    return this.fetchJSON(dataurl);
  }

  pageHtml(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => test)
      ,catchError( this.handleError ));
  }

  getFANList1() {
    let fanUrl;
    if (this.utilityService.getEnvConfig().useMock) {
      
      fanUrl = "assets/mock/dashboard/getFANListMock3.json";
      
    } else {
      fanUrl = this.utilityService.getEnvConfig().getFANList;
    }
    return this.fetchJSON(fanUrl);
  }

  setProdCode(code) {
    if (code === 'KME') {
      sessionStorage.setItem('prodcode', 'Samsung Knox Mobile');
    }
    else if (code === 'ZTP') {
      sessionStorage.setItem('prodcode', 'Android™ Zero-touch');
    }
    else if (code === 'ABM') {
      sessionStorage.setItem('prodcode', 'Apple Business Manager');
    } 
  }
}
